module.exports = __webpack_public_path__ + "img/cz-tags-type.b61ac081.svg";